var map = {
	"./arrow_down.svg": 305,
	"./edit.svg": 306,
	"./github.svg": 307,
	"./heart.svg": 308,
	"./heart_on.svg": 309,
	"./reply.svg": 310,
	"./tip.svg": 311
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 304;


//////////////////
// WEBPACK FOOTER
// ./assets/icon !../node_modules/raw-loader ^\.\/.*\.svg$
// module id = 304
// module chunks = 0